import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ReportComponentModel} from '../reportComponent.model';
import {Injectable} from '@angular/core';
import {ReportComponentSummaryConverter} from './reportComponentSummary.converter';
import {FormConverter} from '../../../../../form/form/api/entity/converter/form.converter';

@Injectable()
export class ReportComponentConverter extends HttpModelConverter<ReportComponentModel> {

    constructor(private summaryConverter: ReportComponentSummaryConverter,
                private formConverter: FormConverter) {
        super();
    }

    protected createInstance(): ReportComponentModel {
        return new ReportComponentModel();
    }

    protected enrichObject(result: ReportComponentModel, src: ReportComponentModel) {
        result.summary = this.summaryConverter.convert(src.summary);
        result.parametersForm = this.formConverter.convert(src.parametersForm);
    }
}
